'use client';
import { Box } from '@castlery/fortress';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FortressImage, FortressVideo } from '@castlery/shared-components';
import { useTrackingTags } from '@castlery/modules-tracking-components';
// const MediaVideo = dynamic(() => import('./usp-video'), { ssr: false });

export const mediaClasses = {
  root: 'media-wrapper',
};
export interface MediaProps {
  media_url: string;
  ratio: number;
  outerModuleName?: string;
  onClick?: () => void;
}

export function Media({ media_url, ratio, outerModuleName = '', onClick, ...rest }: MediaProps) {
  const videoRegex = /\.(mp4|mkv|webm|ogg|avi|mov|flv|wmv)$/i;
  const isVideo = videoRegex.test(media_url);

  const trackingTags = useTrackingTags({
    moduleName: outerModuleName,
    elementName: 'Media Video',
  });

  return (
    <Box className={mediaClasses.root}>
      {isVideo ? (
        // <MediaVideo {...trackingTags} src={media_url} {...(rest || {})} />
        <FortressVideo
          {...trackingTags}
          src={media_url}
          containerConfig={{
            aspectRatio: ratio,
          }}
          muted
          autoPlayOnVisible={true}
          autoPauseOnVisible={true}
          {...(rest || {})}
        />
      ) : (
        <FortressImage
          src={media_url}
          alt={''}
          ratio={ratio}
          objectFit="cover"
          onClick={onClick}
          sizes={['0.4-md', '1-sm', '1-xs']}
          {...(rest || {})}
        />
      )}
    </Box>
  );
}
